import './_jquery.lazyload.min';
import 'assets/img/blockImg_400x400.gif';

export const lazyloadFn = function() {
    // $("img").lazyload({
    //     event: "sporty",
    //     effect: "fadeIn",
    //     threshold: 200,
    //     failure_limit: 10, //預先往下尋找非有序呈現的圖片10張
    //     skip_invisible: false //關閉Lazyload預設忽略不可見圖片(display:none)
    // });

    // var timeout = setTimeout(function() {
    //     $("img").trigger("sporty")
    // }, 2000);

};

$(document).ready(function() {

    // $("img").each(function() {
    //     var that = $(this);
    //     var re = /(.+?.(jpg|bmp|png|jepg|gif))/i;
    //     var href = that.attr("src");
    //     if (re.test(href)) {
    //         that.attr("data-original", href); //轉移原圖片中的真連結到data-original
    //         href = href.replace(re, "assets/img/blockImg_400x400.gif"); //定義未載入前的圖片
    //         that.attr("src", href);
    //     }
    // });

});